<div class="edit-item-comment-component"
     [ngClass]="{
        'item-comment-current-person': (isCurrentPerson | async),
        'item-comment-not-current-person': !(isCurrentPerson | async),
        'item-comment-just-added': justAdded,
        'item-comment-has-update': chainItem.hasUpdate,
    }">
    @if (!chainItem.hasUpdate) {
        <adapt-person-image class="item-comment-person"
                            [person]="chainItem.person"></adapt-person-image>
    }
    <div class="item-comment-container">
        @if (!chainItem.hasUpdate) {
            <div class="item-comment-meta">
                <adapt-link-person [person]="chainItem.person"></adapt-link-person>
                <adapt-entity-timestamp class="item-comment-date-time"
                                        [timestamp]="chainItem.dateTime"></adapt-entity-timestamp>
                @if (chainItem.canUpdate && !isEditing) {
                    <span class="item-comment-editing-buttons">
                        <button adaptButtonIcon="edit"
                                class="btn btn-link"
                                (click)="toggleEditing()"></button>
                        <button adaptButtonIcon="delete"
                                class="btn btn-link"
                                [adaptBlockingClick]="delete"></button>
                    </span>
                }
            </div>
        }
        <div class="item-comment-text"
             [ngClass]="{
                'with-update': chainItem.hasUpdate,
                'without-update': !chainItem.hasUpdate,
            }">
            @switch (isEditing) {
                @case (true) {
                    <adapt-html-editor [(contents)]="chainItem.comment"
                                       forceSize="compact"
                                       [required]="true"
                                       [useMentions]="true"
                                       (isValidChange)="validateComment($event)"></adapt-html-editor>
                }
                @case (true) {
                    <div class="mt-1">
                        <button class="btn btn-primary btn-small"
                                [disabled]="commentIsInvalid"
                                [adaptBlockingClick]="save">Save comment</button>
                        <button class="btn btn-default btn-small"
                                [adaptBlockingClick]="cancel">Cancel</button>
                    </div>
                }
                @case (false) {
                    <div [froalaView]="chainItem.comment"></div>
                }
            }
        </div>
    </div>
</div>
